import styled from "styled-components";

const SearchResultsContainer = styled.div`
  margin-top: 1rem;

  .MuiCard-root {
    transition: all 0.3s ease;
    border-left: 4px solid transparent;

    &:hover {
      border-left-color: ${(props) => props.theme.color.primary};
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
    }
  }

  .MuiChip-root {
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.7rem;
  }

  .MuiPagination-root {
    .MuiPaginationItem-root {
      &.Mui-selected {
        background-color: ${(props) => props.theme.color.primary};
        color: white;

        &:hover {
          background-color: ${(props) => props.theme.color.primary}dd;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .MuiCard-root .MuiCardContent-root {
      padding: 12px;
    }

    .MuiTypography-h6 {
      font-size: 1rem;
    }
  }
`;

export { SearchResultsContainer };